import React, { useEffect, useState } from "react";
import OurLayouts from "../layout";
import medicinedetailsicon from "../../assets/medicinedetailsicon.svg";
import { Modal, Pagination, Button, Input } from "antd";
import axios from "axios";
import TrackingModal from "./TrackingModal";
import { format } from "date-fns";
import nodata from "../../assets/nodata.svg";
import { toast } from "react-toastify";
import customericon from "../../assets/Customer.svg";
import TrackEnquiry from "./TrackEnquiry";
import OrderDetailsModal, {
  OrderDetailsSection,
  OrderDetailsTable,
  orderTableCellClass,
  orderTableHeadClass,
} from "../shared/OrderDetailsModal";

const ClinicMedicineDetails = () => {
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [enquiryModalVisible, setEnquiryModalVisible] = useState(false);
  const [queryDescription, setQueryDescription] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [trackingInfo, setTrackingInfo] = useState(null);
  const [isModalVisible2, setIsModalVisible2] = useState(false);
  const [ticketdata, setTicketdata] = useState();
  const [filters, setFilters] = useState({
    orderId: "",
    fromDate: format(new Date(), "yyyy-MM-dd"),
    toDate: format(new Date(), "yyyy-MM-dd"),
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalElements, setTotalElements] = useState(0);

  const API_URL = process.env.REACT_APP_API_URL;
  const API_NEW_URL = process.env.REACT_APP_API_NEW_URL;
  const hospitalId = localStorage.getItem("hospitalid") || "";
  useEffect(() => {
    fetchOrders();
  }, [filters]);



  async function fetchOrders(page = currentPage) {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const clinicId = localStorage.getItem("clinicId");
    try {
      const resp = await axios.get(
        `${API_URL}orders?orderType=pharmacy&clinicId=${clinicId}` +
        `&fromDate=${filters.fromDate}` +
        `&toDate=${filters.toDate}` +
        (filters.orderId ? `&id=${filters.orderId}` : "") +
        `&page=${page - 1}&size=${pageSize}`,
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        }
      );
      setOrders(resp.data.records || []);
      setFilteredOrders(resp.data.records || []);
      setTotalElements(resp.data.totalElements || 0);
      setCurrentPage(page);
    } catch (err) {
      console.error("Fetch error:", err.response || err);
    }
  }

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSearch = () => {
    fetchOrders(1);
  };

  const handleReset = () => {
    const defaultFilters = {
      orderId: "",
      fromDate: format(new Date(), "yyyy-MM-dd"),
      toDate: format(new Date(), "yyyy-MM-dd"),
    };
    setFilters(defaultFilters);
    fetchOrders(1);
  };

  const handlePageChange = (page) => {
    fetchOrders(page);
  };

  const handleViewDetails = (order) => {
    setSelectedOrder(order);
    setIsModalVisible(true);
  };
  const handleEnquiryModal = (order) => {
    setSelectedOrder(order);
    setEnquiryModalVisible(true);
    setQueryDescription(''); // Reset the input each time modal opens
  }
  const handleEnquiryModalClose = () => {
    setEnquiryModalVisible(false);
    setSelectedOrder(null);
  };
  const handleEnquiry = async () => {
    console.log(selectedOrder, selectedOrder.patientId, "order");
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const response = await axios.get(
      `${API_URL}patient/search?patientId=${selectedOrder.patientId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
      }
    );

    if (response?.data.data.length == 0) {
      toast.error("No Patient Found")
      return
    }

    const Patientdata = response?.data.data[0];
    const payload = {
      patientDetails: {
        // patientdetailsid: "",
        patientId: selectedOrder.patientId,
        medicaseId: "",
        patientName: `${Patientdata.firstName} ${Patientdata.lastName}`,
        dob: Patientdata.dob ||"",
        gender: Patientdata.gender,
        mobileNumber: Patientdata.mobileNumber,
        email: "",
        escallationNumber: "",
        address: selectedOrder.address || Patientdata.address || "",
        pincode: Patientdata.pinCode || "",
      },
      serviceDetailsMessage: queryDescription,
      tickeType: "MEDICINE",
      ticketSource: "HOSPITAL360",
      hospitalId: hospitalId,
    };
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_COMMAND_CENTER_URL}patient/add-ticket-d2c`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const Data = await res.json();
      if (Data.status == 200) {
        toast.success(Data.message);

        // Make the second API call with the ticket ID from the first response
        const ticketId = Data.data.id;
        const orderId = selectedOrder.id;

        try {
          const secondRes = await fetch(
            `${API_URL}createenquiry/order?orderId=${orderId}`,
            {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                tenantId: tenantId,
              },
              body: JSON.stringify({
                ticketId: ticketId,
                ticketStatus: "INPROGRESS",
              }),
            }
          );

          if (secondRes.ok) {
            const responseText = await secondRes.text();
            toast.success(responseText || "Enquiry ticket added successfully");
            console.log("Second API response:", responseText);
            setEnquiryModalVisible(false);
            setSelectedOrder(null);
            setQueryDescription('');
            window.location.reload();
          } else {
            // Try to get error message from response
            let errorMessage =
              "Failed to create enquiry. Please try again later.";
            try {
              const errorData = await secondRes.json();
              errorMessage = errorData.message || errorMessage;
            } catch (e) {
              // If JSON parsing fails, try text
              try {
                const errorText = await secondRes.text();
                errorMessage = errorText || errorMessage;
              } catch (textError) {
                console.error("Could not parse error response:", textError);
              }
            }
            toast.error(errorMessage);
            console.error("Second API error:", errorMessage);
          }
        } catch (secondError) {
          toast.error("Failed to create enquiry. Please try again later.");
        }
      } else {
        toast.error("Failed to register ticket. Please try again later.");
      }
      console.log(Data, "dxfghj");
    } catch (error) {
      console.error("Failed to register ticket", error);
    }
  };
  const handleTrackOrder = async (order) => {
    const token = localStorage.getItem("auth_token");
    const orderNo = order.drugPrescriptions?.drugOrderId;
    try {
      const response = await axios.get(
        `${API_NEW_URL}orderloader/order-status?orderNo=${orderNo}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Check if the response contains an error message
      if (response.data && response.data.message) {
        // Still show the modal with the error message
        setTrackingInfo(response.data);
        setShowModal(true);
      } else {
        setTrackingInfo(response.data);
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error fetching tracking info:", error);
      // Show error toast and set error tracking info
      const errorData = {
        orderNo: orderNo,
        message: "Failed to fetch tracking information. Please try again later."
      };
      setTrackingInfo(errorData);
      setShowModal(true);
    }
  };

  const handleTrackEnquiry = async (order) => {
    const token = localStorage.getItem("auth_token");

    // Get the first ticket ID from the enquiryTickets array
    const ticketId = order.enquiryTickets[0].ticketId;

    console.log("Calling API with ticketId:", ticketId);
    console.log("Order enquiryTickets:", order.enquiryTickets);

    // Call the API to get ticket details
    const response = await fetch(
      `${process.env.REACT_APP_API_COMMAND_CENTER_URL}patient/ticket/${ticketId}`,
      {
        method: "GET",
        headers: {
          accept: "application/json",
  
        },
      }
    );

    console.log("API Response status:", response.status);
    console.log("API Response:", response);

    const ticketData = await response.json();
    setTicketdata(ticketData.data)
    console.log("Ticket details:", ticketData);
    setIsModalVisible2(true);
    // toast.success(`API called successfully! Ticket ID: ${ticketId}`);
  };

  const MedicineCard = ({ order }) => {
    return (
      <div className="relative bg-white rounded-lg p-4 shadow-sm border w-full">
        <div className="flex items-start gap-4">
          <img
            src={medicinedetailsicon}
            alt="Medicine Icon"
            className="w-10 h-10 mt-1"
          />
          <div className="flex-1">
            <p className="text-md font-semibold text-[#003F6B] mb-1">
              <span className="text-green-600">{order?.patientName}</span>
            </p>
            <p className="text-sm text-gray-700 mt-1 mb-1">Id: {order.id}</p>
            {order.createdDate && (
              <p className="text-sm text-gray-700 mb-1">
               Placed On: {order.createdDate 
    ? new Date(order.createdDate).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
    : ""}
              </p>
            )}
          </div>
          {(!order.enquiryTickets || order.enquiryTickets.length === 0) && (
            <img
              className="cursor-pointer w-8 h-8 "
              title="Customer Support"
              src={customericon}
              alt="Customer"
              onClick={() => handleEnquiryModal(order)}
            />
          )}
        </div>

        <div className="mt-4 flex justify-center gap-2">
          <button
            className="border border-[#003F6B] hover:bg-[#003F6B] hover:text-white text-[#003F6B] px-3 py-1.5 rounded text-xs font-medium transition-colors duration-200"
            onClick={() => handleTrackOrder(order)}
          >
            Track Order
          </button>
          <button
            className="border border-[#003F6B] hover:bg-[#003F6B] hover:text-white text-[#003F6B] px-3 py-1.5 rounded text-xs font-medium transition-colors duration-200"
            onClick={() => handleViewDetails(order)}
          >
            View Details
          </button>
          {order.enquiryTickets && order.enquiryTickets.length > 0 && (
            <button
              className="border border-[#00B77E] hover:bg-[#00B77E] hover:text-white text-[#00B77E] px-3 py-1.5 rounded text-xs font-medium transition-colors duration-200"
              onClick={() => handleTrackEnquiry(order)}
            >
              Track Enquiry
            </button>
          )}
        </div>
      </div>
    );
  };

  return (
    <OurLayouts>
      <div className="min-h-screen p-4 bg-[#f1f8f7] rounded-lg">
        <div className="max-w-6xl mx-auto">
          <div className="bg-[#F0F9FB] min-h-screen rounded-lg">
            <div className="flex items-center justify-between mb-3">
              <h2 className="text-xl font-semibold text-[#003F6B]">
                Medicine Orders
              </h2>
            </div>

            {/* Filter Form */}
            <div className="rounded-lg shadow-sm mb-6">
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Order ID
                  </label>
                  <input
                    type="text"
                    name="orderId"
                    value={filters.orderId}
                    onChange={handleFilterChange}
                    className="w-full p-2 border border-gray-300 rounded-md"
                    placeholder="Enter Order ID"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    From Date
                  </label>
                  <input
                    type="date"
                    name="fromDate"
                    value={filters.fromDate}
                    onChange={handleFilterChange}
                    className="w-full p-2 border border-gray-300 rounded-md"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    To Date
                  </label>
                  <input
                    type="date"
                    name="toDate"
                    value={filters.toDate}
                    onChange={handleFilterChange}
                    className="w-full p-2 border border-gray-300 rounded-md"
                  />
                </div>
                <div className="flex items-end space-x-2">
                  <button
                    onClick={handleSearch}
                    className="bg-[#003F6B] text-white px-4 py-2 rounded-md text-sm font-medium"
                  >
                    Search
                  </button>
                  <button
                    onClick={handleReset}
                    className="border border-[#003F6B] text-[#003F6B] px-4 py-2 rounded-md text-sm font-medium"
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>

            {filteredOrders.length > 0 ? (
              <>
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                  {filteredOrders.map((order, index) => (
                    <MedicineCard key={index} order={order} />
                  ))}
                </div>

                {/* Pagination */}
                <div className="flex justify-center mt-6">
                  <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={totalElements}
                    onChange={handlePageChange}
                    showSizeChanger={false}
                  />
                </div>
              </>
            ) : (
              <div className="flex flex-col items-center justify-center h-full text-gray-500">
                <img src={nodata} alt="No Data" className="w-64 h-64 mb-4" />
                <div className="text-center text-gray-600">
                  No orders found for the selected filters.
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {isModalVisible && selectedOrder && (
        <OrderDetailsModal
          open={isModalVisible}
          onClose={() => setIsModalVisible(false)}
          subtitle="Pharmacy Order Details"
          patientName={selectedOrder.patientName}
          status={selectedOrder.enquiryTickets?.[0]?.ticketStatus}
          address={selectedOrder.address}
          addressLabel="Delivery Address"
          infoFields={[
            {
              label: "Drug Order ID",
              value: selectedOrder.drugPrescriptions?.drugOrderId,
              mono: true,
            },
            {
              label: "Placed On",
              value: selectedOrder.createdDate?.split("T")[0],
            },
            { label: "Mobile No", value: selectedOrder.patientMobileNo },
          ]}
        >
          <OrderDetailsSection title="Medicine Details">
            <OrderDetailsTable>
              <thead>
                <tr>
                  <th className={`${orderTableHeadClass} text-left`}>Item Name</th>
                  <th className={`${orderTableHeadClass} text-center`}>Qty</th>
                  <th className={`${orderTableHeadClass} text-right`}>Unit Price</th>
                  <th className={`${orderTableHeadClass} text-right`}>Unit Price After Discount</th>
                  <th className={`${orderTableHeadClass} text-right`}>Total Amount</th>
                </tr>
              </thead>
              <tbody>
                {selectedOrder.drugPrescriptions?.drugs?.map((drug, index) => (
                  <tr key={index}>
                    <td className={orderTableCellClass}>{drug.drugName}</td>
                    <td className={`${orderTableCellClass} text-center`}>{drug.quantity}</td>
                    <td className={`${orderTableCellClass} text-right`}>₹{drug.rate}</td>
                    <td className={`${orderTableCellClass} text-right`}>
                      ₹{drug.discountedAmount || 0}
                    </td>
                    <td className={`${orderTableCellClass} text-right`}>
                      ₹{(drug.discountedAmount * drug.quantity).toFixed(2)}
                    </td>
                  </tr>
                ))}
                <tr className="bg-[#F9FAFB]">
                  <td colSpan="4" className={`${orderTableCellClass} text-right font-bold`}>
                    Total Amount
                  </td>
                  <td className={`${orderTableCellClass} text-right font-bold text-[#00B77E]`}>
                    ₹
                    {selectedOrder.drugPrescriptions?.drugs
                      ?.reduce(
                        (acc, drug) => acc + drug.discountedAmount * drug.quantity,
                        0
                      )
                      .toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </OrderDetailsTable>
          </OrderDetailsSection>
        </OrderDetailsModal>
      )}

      {/* Tracking Modal */}
      {showModal && (
        <TrackingModal
          showModal={showModal}
          setShowModal={setShowModal}
          trackingInfo={trackingInfo}
        />
      )}

      {isModalVisible2 && (
        <TrackEnquiry isModalVisible2={isModalVisible2} setIsModalVisible2={setIsModalVisible2} ticketdata={ticketdata} />

      )}

      <Modal
        title="Order Enquiry"
        visible={enquiryModalVisible}
        onCancel={handleEnquiryModalClose}
        footer={[
          <Button key="back" onClick={handleEnquiryModalClose}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleEnquiry}>
            Submit
          </Button>,
        ]}
      >
        {selectedOrder && (
          <div>
            <p><strong>Order ID:</strong> {selectedOrder.id}</p>
            <p><strong>Patient Name:</strong> {selectedOrder?.patientName}</p>

            <Input.TextArea
              rows={4}
              value={queryDescription}
              onChange={(e) => setQueryDescription(e.target.value)}
              placeholder="Enter your query description here..."
            />
          </div>
        )}
      </Modal>
    </OurLayouts>
  );
};

export default ClinicMedicineDetails;
